document.addEventListener("DOMContentLoaded", function () {
  // Create a header background element
  const headerBg = document.createElement("div");
  headerBg.className = "header-background-overlay";

  // Find the header container and insert our background element
  const headerElement = document.querySelector(".arHeaderSectionAbsolute");
  if (!headerElement) return; // Exit if header not found

  // Insert background element as first child of header
  headerElement.insertBefore(headerBg, headerElement.firstChild);

  // Keep track of last known scroll position
  let lastScrollY = window.scrollY;
  let ticking = false;

  // Handle scroll events
  window.addEventListener(
    "scroll",
    function () {
      lastScrollY = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          // Don't add/remove classes, just change opacity directly
          if (lastScrollY > 50) {
            headerBg.style.opacity = "1";
          } else {
            headerBg.style.opacity = "0";
          }
          ticking = false;
        });

        ticking = true;
      }
    },
    { passive: true }
  );
});

// added next/prev button for tab slider
document.addEventListener('DOMContentLoaded', function () {
  const forceSliders = document.querySelectorAll('grid-slider[data-force-slider]');

  forceSliders.forEach(gridSlider => {
    const sliderEl = gridSlider.querySelector('[data-grid-slider]');
    const slides = sliderEl?.querySelectorAll('[data-grid-item]') || [];

    if (!sliderEl || slides.length < 2) return;

    // Temporarily trick theme JS into enabling slider on touch devices
    const originalTouch = window.theme?.touch;
    window.theme.touch = false;

    // Re-init the slider
    gridSlider.dispatchEvent(new CustomEvent('theme:grid-slider:init'));

    // Restore original touch setting
    window.theme.touch = originalTouch;
  });
});

window.addEventListener('resize', () => {
  forceSliders.forEach(slider => {
    slider.dispatchEvent(new CustomEvent('theme:grid-slider:init'));
  });
});


